import $ from "jquery"
import moment from 'moment'

window.$ = $
window.jQuery = $

window.moment = moment
